import React from 'react'
import { WidgetCard } from '../style'
import { SkeletonLine } from './skeleton.style'

const CurrentMilkPriceWidgetSkeleton: React.FC = () => (
  <WidgetCard>
    {[...Array(3)].map((_, i) => (
      <div key={i} style={{ margin: '1rem', border: '1px solid #e0e0e0', borderRadius: '4px', padding: '12px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <SkeletonLine width='16px' height='16px' style={{ marginBottom: 0, flexShrink: 0 }} />
          <SkeletonLine width='160px' height='16px' style={{ marginBottom: 0 }} />
        </div>
      </div>
    ))}
  </WidgetCard>
)

export default CurrentMilkPriceWidgetSkeleton
